import React from "react"
import { useTranslation } from "react-i18next"
import { Card, CardContent } from "@/components/ui/card"
import { CheckCircle, Shield, Clock, Users, FileCheck, Headphones } from "lucide-react"

export function FeaturesSection() {
  const { t } = useTranslation()

  const features = [
    {
      icon: Shield,
      title: t('home.features.list.background.title'),
      description: t('home.features.list.background.desc'),
    },
    {
      icon: FileCheck,
      title: t('home.features.list.certification.title'),
      description: t('home.features.list.certification.desc'),
    },
    {
      icon: Clock,
      title: t('home.features.list.speed.title'),
      description: t('home.features.list.speed.desc'),
    },
    {
      icon: Users,
      title: t('home.features.list.consultation.title'),
      description: t('home.features.list.consultation.desc'),
    },
    {
      icon: CheckCircle,
      title: t('home.features.list.guarantee.title'),
      description: t('home.features.list.guarantee.desc'),
    },
    {
      icon: Headphones,
      title: t('home.features.list.support.title'),
      description: t('home.features.list.support.desc'),
    },
  ]

  return (
    <section id="employers" className="bg-muted/50 py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-foreground md:text-3xl">{t('home.features.title')}</h2>
          <p className="mt-3 text-muted-foreground">
            {t('home.features.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Card key={index} className="border-0 bg-card shadow-sm transition-shadow hover:shadow-md">
              <CardContent className="p-6">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">{feature.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
